import PropTypes from "prop-types";
import { Link } from "@mui/material";
import { NavLink } from "react-router-dom";

import PillPresenter from "presenters/PillPresenter";
import Placeholder from "components/Placeholder";

import { Category, StyledResponsiveImage } from "./styles";

const Pill = ({ item, loading = false }) => {
  if (loading)
    return (
      <Category>
        <Placeholder variant="rect" ratio="4/3" />
      </Category>
    );

  return (
    <Link
      id={`home-featured-${PillPresenter.name(item)
        .replace(/\s/g, "-")
        .toLowerCase()}`}
      to={PillPresenter.url(item)}
      component={NavLink}
    >
      <Category>
        <StyledResponsiveImage
          src={PillPresenter.desktopImage(item)}
          alt={PillPresenter.name(item)}
          width={296}
          height={222}
          widthMobile={160}
        />
      </Category>
    </Link>
  );
};

Pill.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.shape({}),
  }),
  loading: PropTypes.bool,
};

export default Pill;
